import { jsx as _jsx } from "react/jsx-runtime";
import { ReactSVG } from 'react-svg';
import PromoIcon from '../../Images/icon/percent.svg';
export function YoProcent() {
    return (_jsx(ReactSVG, { src: PromoIcon, className: "icon" }));
}
